module.exports = __webpack_public_path__ + "static/media/aaron-shaw.1638fa6d.md";